import React from "react";

const ABOUT_IMG = "https://customer-assets.emergentagent.com/job_vela-autentica/artifacts/3cu4nomp_PHOTO-2025-01-24-16-38-38.jpg";

export default function About() {
  return (
    <section id="sobre" className="section-pad wood-bg" data-testid="about-section">
      <div className="container-tight grid md:grid-cols-12 gap-12 md:gap-16 items-center">
        <div className="md:col-span-5 order-2 md:order-1">
          <div className="relative">
            <img
              src={ABOUT_IMG}
              alt="Detalles de cubierta de madera del velero Zorba"
              className="w-full h-[520px] md:h-[640px] object-cover rounded-md shadow-xl"
            />
            <div className="absolute -bottom-5 -right-5 hidden md:block bg-navy text-white px-6 py-5 rounded-md shadow-lg">
              <p className="font-heading text-2xl">Zorba</p>
              <p className="label-eyebrow text-white/70 mt-1">Desde el primer día</p>
            </div>
          </div>
        </div>

        <div className="md:col-span-7 order-1 md:order-2">
          <p className="label-eyebrow text-wood mb-5" data-testid="about-eyebrow">
            El barco
          </p>
          <h2 className="font-heading text-4xl md:text-5xl leading-tight text-navy" data-testid="about-title">
            El Zorba, un clásico vivo.
          </h2>
          <div className="mt-8 space-y-5 text-navy/80 text-lg leading-relaxed">
            <p>
              No es un barco más. El Zorba es un velero clásico de madera de 18 metros, con más de 50 años de historia y una forma de navegar que ya no se encuentra fácilmente.
            </p>
            <p>
              Durante años navegó bajo la bandera de Greenpeace. Después fue recuperado y restaurado respetando su esencia original: la madera, las líneas clásicas y ese carácter propio de los barcos hechos para durar.
            </p>
            <p>
              Su silueta no pasa desapercibida. La estética del Zorba, su historia y su personalidad lo han convertido también en escenario de festivales marítimos, documentales y producciones audiovisuales, entre ellas <em>Romería</em>, la película de Carla Simón estrenada en Cannes 2025.
            </p>
            <p>
              Hoy, el Zorba vuelve al mar desde Portonovo con una propuesta íntima y diferente: salidas privadas, experiencias a medida y navegación tranquila por las Rías Baixas.
            </p>
          </div>

          <ul className="mt-10 grid sm:grid-cols-2 gap-x-8 gap-y-3 text-navy/80">
            {[
              "18 metros de eslora",
              "Más de 50 años de historia",
              "Construcción clásica en madera",
              "Restauración respetando su esencia original",
              "Etapa bajo bandera de Greenpeace",
              "Presente en cine, documentales y festivales marítimos",
              "Hasta 12 pasajeros más tripulación",
              "Dog friendly: perros bienvenidos a bordo",
            ].map((b) => (
              <li key={b} className="flex items-start gap-3 text-base">
                <span className="mt-2 block w-1.5 h-1.5 bg-wood rounded-full flex-shrink-0" />
                {b}
              </li>
            ))}
          </ul>

          <div className="mt-10 grid grid-cols-3 gap-6">
            {[
              { k: "Eslora", v: "18 m" },
              { k: "Capacidad", v: "12 + tripulación" },
              { k: "Patrón", v: "Incluido" },
            ].map((s) => (
              <div key={s.k} className="border-l-2 border-wood pl-4">
                <p className="label-eyebrow text-navy/50">{s.k}</p>
                <p className="font-heading text-xl text-navy mt-1">{s.v}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
